import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import styles from "./ModalConfirmRegisterNewValue.module.scss";
import Button from "../../../UiComponents/Button";

const ModalConfirmRegisterNewValue = ({
  setOverlay,
  setModalConfirmRegisterNewValue,
  isCheckedDateUpdate,
  checkHandler,
  importSerialNumber,
  setImportSerialNumber,
  importSoundcardSerial,
  setImportSoundcardSerial,
  setModalConfirmImport,
  registerNewValue,
  setSerialNumber,
  setSerialSoundcardNumber,
  previousSerialNumber,
  previousSerialSoundcardNumber,
  handleSerialNumberChange,
  isImportMode,

  // Calibration pour Bone (Conduction osseuse)
  previousCalibTonal,
  previousCalibVocal,
  setCalibTonal,
  setCalibVocal,

  // Calibration pour Headphones (Casque)
  setCalibGeneral,
  setCalibTonalLeft,
  setCalibTonalRight,
  setCalibVocalLeft,
  setCalibVocalRight,
  previousCalibGeneral,
  previousCalibTonalLeft,
  previousCalibTonalRight,
  previousCalibVocalLeft,
  previousCalibVocalRight,

  previousDateCalibration,
  setDateCalibration,
  // maj
  maj,
  setMaj,
}) => {
  // ✅ Fonction qui met à jour les inputs de BoneCalib / HeadphonesCalib
  const handleSerialCheckboxChange = (type) => {
    if (type === "serialNumber") {
      const newImportSerial = !importSerialNumber;
      setImportSerialNumber(newImportSerial);
      handleSerialNumberChange(newImportSerial, importSoundcardSerial);
    } else if (type === "serialSoundCard") {
      const newImportSoundCard = !importSoundcardSerial;
      setImportSoundcardSerial(newImportSoundCard);
      handleSerialNumberChange(importSerialNumber, newImportSoundCard);
    }
  };

  // ✅ Fonction qui restaure les anciennes valeurs
  const handleCancel = () => {
   if(setSerialNumber) setSerialNumber(previousSerialNumber);
    if (setSerialSoundcardNumber) setSerialSoundcardNumber(previousSerialSoundcardNumber);
    if(setDateCalibration) setDateCalibration(previousDateCalibration);



    // Gestion dynamique en fonction des props présentes
    if (setCalibTonal && previousCalibTonal) setCalibTonal(previousCalibTonal);
    if (setCalibVocal && previousCalibVocal) setCalibVocal(previousCalibVocal);

    if (setCalibGeneral && previousCalibGeneral) setCalibGeneral(previousCalibGeneral);
    if (setCalibTonalLeft && previousCalibTonalLeft) setCalibTonalLeft(previousCalibTonalLeft);
    if (setCalibTonalRight && previousCalibTonalRight) setCalibTonalRight(previousCalibTonalRight);
    if (setCalibVocalLeft && previousCalibVocalLeft) setCalibVocalLeft(previousCalibVocalLeft);
    if (setCalibVocalRight && previousCalibVocalRight) setCalibVocalRight(previousCalibVocalRight);

    // Fermer la modale
    setOverlay(false);
    setModalConfirmRegisterNewValue(false);
    setModalConfirmImport(false);
    setMaj(!maj)
  };

  return (
    <div className={styles.modalConfirm}>
   
      <span className={styles.title}>Voulez-vous enregistrer les nouvelles données ?</span>

      <div className={styles.options}>
        {isImportMode && (
          <>
            <div>
              <input
                type="checkbox"
                checked={importSerialNumber}
                onChange={() => handleSerialCheckboxChange("serialNumber")}
              />
              <label>Numéro de série du transducteur</label>
            </div>
            <div>
              <input
                type="checkbox"
                checked={importSoundcardSerial}
                onChange={() => handleSerialCheckboxChange("serialSoundCard")}
              />
              <label>Numéro de série carte son</label>
            </div>
          </>
        )}
        <div>
          <input
            type="checkbox"
            checked={isCheckedDateUpdate}
            onChange={checkHandler}
          />
          <label>Mettre à jour avec la date du jour</label>
        </div>
      </div>

      <div className={styles.actions}>
        <Button onPress={handleCancel} text="Annuler" styles={"btnDelete"} />
        <Button
          onPress={registerNewValue}
          text="Enregistrer"
          styles={"btnValidation"}
        />
      </div>
    </div>
  );
};

export default ModalConfirmRegisterNewValue;
